import useReveal         from "../hooks/useReveal";
import Navbar            from "../components/Navbar/Navbar";
import Hero              from "../components/Hero/Hero";
import TrendingGames     from "../components/TrendingGames/TrendingGames";
import FeaturedWork      from "../components/FeaturedWork/FeaturedWork";
import Platforms         from "../components/Platforms/Platforms";
import RecentGames       from "../components/RecentGames/RecentGames";
import WhyChoose         from "../components/WhyChoose/WhyChoose";
import Newsletter        from "../components/Newsletter/Newsletter";
import Footer            from "../components/Footer/Footer";
import "./Home.css";

export default function Home() {
  /* activate scroll-reveal once the page mounts */
  useReveal();

  return (
    <div className="home-page-theme">
      <Navbar />
      <Hero />
      <TrendingGames />
      <FeaturedWork />
      <Platforms />
      <RecentGames />
      <WhyChoose />
      <Newsletter />
      <Footer />
    </div>
  );
}
